import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import Tabs from "@material-ui/core/Tabs";
import TabPanel from "@material-ui/lab/TabPanel";
import { VerticalTabsProps, TabType } from "./VerticalTabs.types";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
    display: "flex",
  },
  tabSection: {
    backgroundColor: "white",
    zIndex: 9,
  },
  tabList: {
    backgroundColor: "white",
    width: "unset",
    boxShadow: "none",
  },
  tab: {
    border: "1px solid rgba(226, 229, 230, 0.35)",
    borderBottom: "none",
    backgroundColor: "#FFFFFF",
    color: "#737B7D",
    height: "47px",
    minWidth: "300px",
    borderRadius: "4px 0px 0px 4px",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontSize: "14px",
    fontWeight: "600" as any,
    lineHeight: "22px",
    letterSpacing: "0.1px",
    textTransform: "none",
    paddingLeft: "20px",

    "&:last-of-type": {
      borderBottom: "1px solid rgba(226, 229, 230, 0.35)",
    },

    "& .MuiTab-wrapper": {
      flexDirection: "row",
      justifyContent: "flex-start",
    },
  },
  tabPanel: {
    border: "1px solid rgba(226, 229, 230, 0.35)",
    overflowY: "auto",
    left: "321px",
    padding: "20px",
    flexGrow: "1" as any,

    backgroundColor: "#FFFFFF",
    boxShadow: "0px 4px 16px rgba(55, 63, 65, 0.06)",
    borderRadius: "0px 10px 10px 10px",
  },
  selectedTab: {
    backgroundColor: "#FFFFFF",
    borderRight: "1px solid white",
    color: "#373F41",
  },
}));

export const VerticalTabs: React.FC<VerticalTabsProps> = ({ tabs }) => {
  const classes = useStyles();
  const [tab, setTab] = React.useState(tabs[0].name);

  const handleChange = (event: React.ChangeEvent<{}>, newTab: string) => {
    setTab(newTab);
  };

  return (
    <div className={classes.root}>
      <TabContext value={tab}>
        <AppBar position="static" className={classes.tabList}>
          <Tabs
            orientation="vertical"
            onChange={handleChange}
            value={tab}
            className={classes.tabSection}
            TabIndicatorProps={{
              style: {
                display: "none",
              },
            }}
          >
            {tabs.map((tab: TabType) => (
              <Tab
                disableRipple
                classes={{ root: classes.tab, selected: classes.selectedTab }}
                label={tab.name}
                value={tab.name}
                key={tab.name}
              />
            ))}
          </Tabs>
        </AppBar>
        {tabs.map((tab: TabType) => (
          <TabPanel
            className={classes.tabPanel}
            value={tab.name}
            key={tab.name}
          >
            {tab.content}
          </TabPanel>
        ))}
      </TabContext>
    </div>
  );
};
